import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import "flag-icons/css/flag-icons.min.css";
import "@/i18n";
import App from "@/App";

// Send the admin session cookie with every API request.
// Required for the cookie-based admin auth (see backend/admin_auth.py).
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
